// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import {
	BunnyDevice,
	BunnyDeviceSettings,
} from '@dsbunny/rmm-client';
import { CLIENT_ID } from './config.js';

export class BunnyBrowserDevice extends BunnyDevice {
	static override URN: string = 'urn:dsbunny:device:browser';

	override get uri(): string {
		return BunnyBrowserDevice.URN;
	}

	override get tags(): string[] {
		return [
			'browser',
		];
	}

	constructor(options: BunnyDeviceSettings) {
		super(options);
	}

	override async clientId() {
		return CLIENT_ID;
	}

	override async _onUriChanged(uri: string | null): Promise<void> {
		this._is_active = (uri === BunnyBrowserDevice.URN);
	}
}
